import type { AdminEnvironment } from "@/lib/environment";

interface EnvironmentBadgeProps {
  environment: AdminEnvironment | null;
}

export function EnvironmentBadge({ environment }: EnvironmentBadgeProps) {
  if (!environment) {
    return (
      <span className="inline-flex h-9 items-center gap-2 rounded-lg border border-status-danger/30 bg-status-danger/10 px-3 text-sm text-status-danger">
        <i className="ri-error-warning-line" />
        未选择环境
      </span>
    );
  }

  return (
    <span
      className={`inline-flex h-9 items-center gap-2 rounded-lg border px-3 text-sm ${
        environment.is_prod
          ? "border-status-warning/40 bg-status-warning/10 text-status-warning"
          : "border-brand/20 bg-brand/10 text-brand"
      }`}
    >
      <i className={environment.is_prod ? "ri-alert-line" : "ri-map-pin-line"} />
      {environment.display_name}
    </span>
  );
}
